import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

import { Flexer, Spacer, Field } from '@ontruck/orc';
import DatePicker from 'react-datepicker';
import { withFormikField, getFormikError } from 'utils/formik';

const t = {
  start_from: 'From',
  end_on: 'To',
};

class FromTo extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChangeStartFrom = this.handleChangeStartFrom.bind(this);
    this.handleChangeEndOn = this.handleChangeEndOn.bind(this);
    this.customInputFor = this.customInputFor.bind(this);
  }

  customInputFor(field_name) {
    const { form } = this.props;

    return (
      <div>
        <Field
          label={t[field_name]}
          value={
            form.values[field_name]
              ? moment(form.values[field_name]).format('dddd DD MMM YYYY')
              : ''
          }
          invalid={!!getFormikError({ field: { name: field_name }, form })}
        />
      </div>
    );
  }

  handleChangeStartFrom(date) {
    const { setFieldValue, values } = this.props.form;

    if (moment(values.end_on).startOf('day').diff(date.clone().startOf('day'), 'days') < 7) {
      setFieldValue('end_on', null);
    }

    setFieldValue('start_from', date.format('YYYY-MM-DD'));
  }

  handleChangeEndOn(date) {
    const { setFieldValue } = this.props.form;
    setFieldValue('end_on', date.format('YYYY-MM-DD'));
  }

  render() {
    const { form } = this.props;

    const { start_from = '', end_on = '' } = form.values;

    const _start_from = start_from ? moment(start_from) : null;
    const _end_on = end_on ? moment(end_on) : null;

    return (
      <Flexer.Parent>
        <Spacer mRight="S">
          <DatePicker
            selected={_start_from}
            startDate={_start_from}
            endDate={_end_on}
            minDate={moment().add(1, 'days')}
            maxDate={moment().add(1, 'year').add(1, 'days')}
            selectsStart
            customInput={this.customInputFor('start_from')}
            onChange={this.handleChangeStartFrom}
          />
        </Spacer>

        <Spacer mRight="S">
          <DatePicker
            selected={_end_on}
            startDate={_start_from}
            endDate={_end_on}
            minDate={_start_from.clone().add(7, 'days')}
            maxDate={_start_from.clone().add(1, 'year')}
            selectsEnd
            customInput={this.customInputFor('end_on')}
            onChange={this.handleChangeEndOn}
          />
        </Spacer>
      </Flexer.Parent>
    );
  }
}

FromTo.propTypes = {
  form: PropTypes.object,
};

export default withFormikField(FromTo);
